<template>
  <div class="card-item-wrapper p-d-12">
    <div class="card-item">
      <div class="f-regular f-12 f-c-yellow konfirmasi-penghapusan"
           v-if="transaksi.status_hapus === 1 && transaksi.idpermintaanhapus !== 0">
        Menunggu konfirmasi penghapusan
      </div>
      <div class="top-card">
        <input type="text" :id="'idtransaksi-'+transaksi.idtransaksi" class="copy-input"
               :value="transaksi.idtransaksi">

        <div class="f-semi f-16 f-c-black " v-if="!isSearch">{{ transaksi.idtransaksi }}
          <img src="../../../../assets/icons/copy-full.svg" alt=""
               @click="copyToClipboard(transaksi.idtransaksi)"
               class="m-r-4 copy-area"
               style="height: 24px; margin-top: -2px"
          />
        </div>
        <div class="f-semi f-16 f-c-black" v-else>
          <span v-html="searchHighlight(transaksi.idtransaksi, keySearch)"></span>
          <img src="../../../../assets/icons/copy-full.svg" alt=""
               @click="copyToClipboard(transaksi.idtransaksi)"
               class="m-r-4 copy-area"
               style="height: 24px; margin-top: -2px"
          />
        </div>
        <div class="card-menu-vertical"></div>
      </div>
      <div class="f-regular f-13 f-c-midgrey m-t-4 badge color-yellow" v-if="transaksi.idtransaksi_lama">
        Menggantikan transaksi <span class="f-c-black"> {{ transaksi.idtransaksi_lama }}</span>
      </div>
      <div class="f-regular f-13 f-c-midgrey m-t-4" v-if="transaksiGlobal">
        <img src="../../../../assets/icons/mood-happy.svg" alt=""
             class="m-r-4"
             style="height: 13px; margin-top: -2px"
        />
        <span v-if="!isSearch">{{ transaksi.nama_customer }} - {{ transaksi.telp_customer }} </span>
        <span v-else
              v-html="searchHighlight(transaksi.nama_customer + ' - ' +  transaksi.telp_customer, keySearch)"
              class="f-c-black"></span>
      </div>
      <div class="d-inline-block" :class="{'m-t-4' : !transaksiGlobal}">
				<span class="f-regular f-13 f-c-midgrey m-r-8">
					<img src="../../../../assets/icons/file.svg" alt=""
               v-if="transaksi.jenis_transaksi === 1"
               class="m-r-4"
               style="height: 13px; margin-top: -2px"
          />
					<img src="../../../../assets/icons/archive.svg" alt=""
               v-if="transaksi.jenis_transaksi === 2"
               class="m-r-4"
               style="height: 13px; margin-top: -2px"
          />
					<span>{{ transaksi.jenis_transaksi_formated }}</span>
				</span>
        <span class="f-regular f-13 f-c-midgrey">
					<img src="../../../../assets/icons/outlet-out-muted.svg" alt=""
               class="m-r-4"
               style="height: 13px; margin-top: -2px"
          />
					<span v-if="!isSearch">{{ transaksi.nama_outlet }}</span>
					<span class="f-c-black" v-else v-html="searchHighlight(transaksi.nama_outlet, keySearch)"></span>
				</span>
      </div>
      <div class="f-regular f-13 f-c-midgrey">
        Diterima: {{ $moment(transaksi.waktu_diterima_raw).format("DD MMMM YYYY HH:mm") }}
      </div>
      <div class="d-flex-between-center">
        <div class="f-regular f-13 f-c-midgrey" v-if="transaksi.status_selesai === 2">
          Selesai: {{ $moment(transaksi.waktu_selesai_pengerjaan_raw).format("DD MMMM YYYY HH:mm") }}
                </div>
                <div class="f-regular f-13 f-c-midgrey" v-else>
                    Estimasi: {{ $moment(transaksi.waktu_selesai_raw).format("DD MMMM YYYY HH:mm") }}
        </div>
        <div class="f-regular f-13 f-c-midgrey">
          {{
            transaksi.persentase_transaksi.toString().split(".").length > 1 ?
                transaksi.persentase_transaksi.toFixed(2) :
                transaksi.persentase_transaksi
          }}%
          <SOProgressBarCircle
              :progress="transaksi.persentase_transaksi"
              :radius="12"
              :stroke="3"
              :green="kondisiSudahDiambil(transaksi) || kondisiSudahDiantar(transaksi)"
              :blue="kondisiBelumDiambil(transaksi) || kondisiBelumDiantar(transaksi) || kondisiSebagianDiambil(transaksi)"
              :yellow="transaksi.persentase_transaksi < 100"
          />
        </div>
      </div>

      <div class="separator-line m-x-min m-t-10"></div>
      <div class="bottom-card m-t-8 d-flex-between-center align-items-center" style="position: relative">
        <div class="d-inline">
					<span class="f-semi f-14 f-c-black" v-if="transaksi.total_harga !== undefined">
						{{ transaksi.total_harga | currency }}
					</span>
          <span class="badge color-red" v-if="transaksi.status_bayar === 0 && transaksi.status_lunas === 0">Blm Bayar</span>
          <span class="badge color-red" v-if="transaksi.status_bayar === 1 && transaksi.status_lunas === 0">Blm Lunas</span>
          <span class="badge color-green" v-if="transaksi.status_lunas === 1">Lunas</span>

          <span class="badge color-green" v-if="transaksi.jenis_bayar!=''">{{ transaksi.jenis_bayar }}</span>
        </div>
        <div class="f-regular f-12 f-c-midgrey">
          {{ transaksi.status_transaksi_format }}
        </div>
      </div>
      <div
          v-if="isWhiteLabel"
          :id="`card_footer_transaksi_snapclean${transaksi.id}`"
          class="employee card_footer f-12 f-c-secondary-kasir-smartlink f-regular m-x-min confirmed"
      >
        <img
            src="@/assets/icons/ic_phone_whitelabel.svg"
            alt=""
            class="m-r-4"
            style="height: 13px; margin-top: -2px"
        /> Loyalty Apps
      </div>

      <div class="clik"
           data-toggle="dropdown"
           aria-haspopup="true"
           aria-expanded="false"
           @click="showToggleCount(transaksi.idtransaksi)">
      </div>
      <div class="dropdown-menu garis-listkomisi">
        <button
            class="dropdown-item icon-2"
            v-if="validateAccess('transactionRegular.read')"
            @click="transaksi.status_hapus === 1 && transaksi.idpermintaanhapus !== 0 ? konfirmasiPenghapusan(transaksi.idpermintaanhapus, $event) : detail(transaksi.idtransaksi, $event)"
        >
					<span class="mar-right-10">
						<img src="../../../../assets/icons/file-text.svg">
					</span>
          Detail Nota
        </button>
        <button class="dropdown-item icon-2" @click="status(transaksi.idtransaksi, $event)"
                v-if="validateAccess('transactionRegular.read')">
					<span class="mar-right-10">
						<img src="../../../../assets/icons/layers.svg">
					</span>
          Status
        </button>
        <button class="dropdown-item icon-2" @click="konfirmasiPenghapusan(transaksi.idpermintaanhapus, $event)"
                v-if="transaksiGlobal && transaksi.status_hapus === 1 && validateAccess('deleteRegular.confirm')"
        >
					<span class="mar-right-10">
						<img src="../../../../assets/icons/clipboard-check.svg">
					</span>
          <b>Konfirmasi</b>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import SOProgressBarCircle from "@/so-components/global/ui/SOProgressBarCircle";

export default {
  name: "SOCardTransaksi",
  components: {
    SOProgressBarCircle
  },
  data: {
    "toggleCount": 0,
  },
  props: {
    transaksi: Object,
    isSearch: Boolean,
    keySearch: String,

    transaksiGlobal: Boolean,
  },
  computed: {
    isWhiteLabel() {
      return this.transaksi.transaksi_loyalty != null
    }
  },
  methods: {
    detail(id, event) {
      this.$store.commit("transaksiModule/setScrollPosition", event.pageY)
      this.$router.push("/transaksi/reguler/detail/" + id)
      this.smartTrackingClick("detail_transaksi_reguler", {"idtransaksi": id});

    },
    status(id, event) {
      this.$store.commit("transaksiModule/setScrollPosition", event.pageY)
      this.$router.push("/transaksi/reguler/detail/status/" + id + `${this.isWhiteLabel ? `/${this.transaksi.transaksi_loyalty.id}` : ""}`)
      this.smartTrackingClick("status_transaksi_reguler", {"idtransaksi": id});
    },
    konfirmasiPenghapusan(id, event) {
      this.$store.commit("transaksiModule/setScrollPosition", event.pageY)
      this.$router.push({
        name: "PembatalanTransaksiReguler.detail.data",
        params: {id: id},
        query: {back: "TransaksiGlobal"},
      });
      this.smartTrackingClick("konfirmasi_hapus_transaksi_reguler", {"idtransaksi": id});
    },
    copyToClipboard(idtransaksi) {
      var copyText = document.getElementById("idtransaksi-" + idtransaksi);
      copyText.select();
      copyText.setSelectionRange(0, 99999)
      document.execCommand("copy");
      console.log(copyText);
      this.$toast.success("ID " + idtransaksi + " Berhasil Tersalin")
      this.smartTrackingView("transaksi_reguler_salin", {"idtransaksi": id});
    },
    showToggleCount(id) {
      if (this.toggleCount === 0) {
        this.toggleCount = 1;
        // this.smartTrackingView("transaksi_reguler_option_close",{"idtransaksi":id});
      } else {
        this.toggleCount = 0;
        // this.smartTrackingView("transaksi_reguler_option_open",{"idtransaksi":id});

      }
    }
  }
}
</script>

<style scoped>
.konfirmasi-penghapusan {
  background: linear-gradient(90deg, #FFF8E1 0%, #FFFFFF 100%);
  padding: 4px 18px;
  margin: -10px -18px 10px;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
}

.copy-area {
  padding-left: 5px;
  position: absolute;
  z-index: 2;
}

.copy-input {
  opacity: 0;
  width: 10px;
  height: 10px;
  position: absolute;
}

.card-item .employee,
.detail .detail-footer {
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
  margin: 10px -18px -10px -18px !important;
  padding: 8px 18px !important;
  background-image: linear-gradient(to right, #E5F6F5, #FFFFFF);
}

</style>